import { getMenuItemPath } from './mobileNavigationDuplicateFiltering';

const MAX_FAVORITE_TABS = 4;

export const MOBILE_PLATFORM_BOTTOM_ACTION_TYPES = {
  PLATFORM_NAVIGATION: 'platform-navigation',
  MODULE_MENU: 'module-menu',
  MODULE_GRID: 'module-grid',
};

const MENU_TAB = {
  id: 'platform-module-menu',
  name: 'menu',
  label: 'common.navigation.menu',
  icon: 'icon-Menu_POV',
  actionType: MOBILE_PLATFORM_BOTTOM_ACTION_TYPES.MODULE_MENU,
};

const HOME_TAB = {
  id: 'platform-module-home',
  name: 'platform-home',
  label: 'common.navigation.home',
  icon: 'icon-Dashboard_POV',
  actionType: MOBILE_PLATFORM_BOTTOM_ACTION_TYPES.MODULE_GRID,
};

const getDescendants = (item) => {
  if (!item?.children?.length) return [];

  return item.children.flatMap((child) => [
    child,
    ...getDescendants(child),
  ]);
};

const isMobileFavorite = (item) => item.available_in_mobile && item.favorite_in_mobile;

const filterDuplicateFavoriteItems = (items) => {
  const paths = new Set();

  return items.filter((item) => {
    const path = getMenuItemPath(item);
    if (!path) return true;
    if (paths.has(path)) return false;
    paths.add(path);
    return true;
  });
};

const hasMobileVisibleMenuItems = (item) => getDescendants(item)
  .some((child) => child.available_in_mobile);

const buildFavoriteTab = (item, getItemTitle) => ({
  id: item.uid,
  name: item.key || item.uid,
  label: getItemTitle(item),
  icon: item.icon || 'icon-Menu_POV',
  actionType: MOBILE_PLATFORM_BOTTOM_ACTION_TYPES.PLATFORM_NAVIGATION,
  isAlreadyTranslated: true,
  platformNavigationItem: item,
});

export const buildMobilePlatformBottomTabs = ({
  activeItem,
  fallbackTabs,
  getItemTitle,
  isMobilePlatformNavigationActive,
  hasMultipleModules = true,
}) => {
  if (!isMobilePlatformNavigationActive || !activeItem || activeItem.isBMP) {
    return fallbackTabs;
  }

  const hasMenuItems = hasMobileVisibleMenuItems(activeItem);
  // The module grid only makes sense when there is another module to switch to. With a
  // single module and nothing to open in the menu there is no platform tab to reserve.
  if (!hasMultipleModules && !hasMenuItems) {
    return fallbackTabs;
  }

  const mobileFavoriteItems = getDescendants(activeItem).filter(isMobileFavorite);
  const uniqueFavoriteItems = filterDuplicateFavoriteItems(mobileFavoriteItems);
  const favoriteTabs = uniqueFavoriteItems
    .slice(0, MAX_FAVORITE_TABS)
    .map((item) => buildFavoriteTab(item, getItemTitle));

  const reservedTab = hasMenuItems ? MENU_TAB : HOME_TAB;
  return [...favoriteTabs, reservedTab];
};

export default buildMobilePlatformBottomTabs;
